<template>
    <el-carousel
        ref="carousel_1"
        :interval="9000">
        <el-carousel-item>
            <h3>Webhook 通知</h3>
            <br/>
            <p>当有工单需要你处理，或你的工单有别人处理时，系统可以发送及时的通知，给你的钉钉或企业微信群，或者推送给你的另一个业务系统</p>
            <br/>
            <p>联系 <a target="_blank" href="/ticket/h">管理员</a></p>
        </el-carousel-item>

        <el-carousel-item>
            <h3>工单模板</h3>
            <br/>
            <p>你可以使用工单模板, 存储一些你经常输入的内容, 在需要时引用; 就可以不再很多次输入重复的内容了</p>
            <br/>
            <p>可以在新建工单, 回复工单, 指派工单时, 在内容输入框的下面, 点击 <b>[模板]</b> 按钮引用</p>
            <br/>
            <p>如果需要定制相关内容, 可向 <a target="_blank" href="/ticket/h">管理员</a> 联系</p>
        </el-carousel-item>

        <el-carousel-item>
            <h3>什么是视图</h3>
            <br/>
            <p>视图的本质是一些查询条件,用以筛选出我们关心的一些工单</p>
            <br/>
            <p>例如, <b>与我有关</b>, 包含了, 当前用户创建的, 或指派给当前用户, 或抄送给当前用户, 并且状态为未关闭的所有工单</p>
            <br/>
            <p>如果你需要定制一些你独有的查询条件, 例如: 类型为招募且状态为未完成的; 或内容包含工资且创建时间在半个月以内的, 可向 <a target="_blank" href="/ticket/h">管理员</a> 联系</p>
        </el-carousel-item>

        <el-carousel-item>
            <h3>工作流(自定义流程)</h3>
            <br/>
            <p>联系 <a target="_blank" href="/ticket/h">管理员</a></p>
        </el-carousel-item>

        <el-carousel-item>
            <h3>自定义表单</h3>
            <br/>
            <p>联系 <a target="_blank" href="/ticket/h">管理员</a></p>
        </el-carousel-item>

        <el-carousel-item>
            <h3>工单系统能做什么</h3>
            <br/>
            <p>不具体吹了, 参考<a target="_blank" href="https://www.baidu.com/s?wd=工单系统">百度搜索</a>, <a target="_blank" href="https://baike.baidu.com/item/工单系统">百度百科</a></p>
            <br/>
            <p>联系 <a target="_blank" href="/ticket/h">管理员</a></p>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    name: 'UserGuideCarousel'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/UserGuideCarousel.vue